import {isEmpty, debounce, forEach, cloneDeep} from "lodash";
import {bytesFormatter} from '../helpers/stringHelpers';
import ShowNotificationMixin from "./ShowNotificationMixin";


export default {
    mixins: [
        ShowNotificationMixin
    ],
    props: {
        maxFiles: {
            type: Number,
            required: false,
            default: 5,
        },
        fileTypes: {
            type: String,
            required: false,
            default: '.jpeg, .jpg, .jpe, .png, .bmp, .svg, .xlsx, .xls, .doc, .docx, .7z, .zip, .pdf, .xltm, .xlsm, .xlsb, .ods, .ots, .xltx, .pptx, .odp, .ppt, .pps'
        },
        maxFileSize: {
            type: Number,
            required: false,
            default: 10,
        },
    },
    computed: {
        componentUid() {
            return this._uid;
        },
        maxFilesReached() {
            return this.maxFiles <= this.files.length;
        },
        fileTypesArray() {
            return this.fileTypes.split(',').map((item) => item.trim());
        },
        maxFileSizeKb() {
            return this.maxFileSize * Math.pow(10, 6);
        }
    },

    methods: {
        bytesFormatter,
        checkFileExtension(file) {
            let fileExtension = '.' + file.name.split('.').pop().trim();
            return !!this.fileTypesArray.includes(fileExtension.toLowerCase());
        },

        checkFileExists(file) {
            const existingFile = this.files.filter(fileItem => (fileItem.name === file.name &&
                fileItem.size === file.size && fileItem.type === file.type));
            return !!existingFile.length;
        },

        checkFileSize(file) {
            return file.size <= this.maxFileSizeKb;
        },

        addFileFromInput(files) {
            let droppedFiles = Array.from(files);
            if (droppedFiles.length > (this.maxFiles - this.files.length)) {
                droppedFiles.length = this.maxFiles - this.files.length;
            }
            droppedFiles.forEach(f => {
                if (this.checkFileSize(f) && this.checkFileExtension(f)) {
                    this.files.push(f);
                } else if (!this.checkFileExtension(f)) {
                    this.showNotification({
                        message: `Invalid file format. Please upload one of
                            the following file types: ${this.fileTypes}.`,
                        type: 'error'
                    });
                } else {
                    this.showNotification({
                        message: `File is larger than ${this.bytesFormatter(this.maxFileSizeKb)}`,
                        type: 'error'
                    });
                }
            });
            this.$emit('input', this.files);
        },
    },
};
